module.exports = __webpack_public_path__ + "static/media/subinfo-dollar.c09ae191.svg";